import Vue from 'vue';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'contractAgreement',
    props: {
        agreementData: {
            type: Object,
            default: function () {
                return {
                    name: '',
                    currentData: {},
                };
            },
        },
        isShowOptBtn: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            usernameZh: '',
            planTotalAmount: 0,
            planTotalDate: '',
            currentAgreement: {},
        };
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        signAgreement: function (signStatus) {
            var _this = this;
            var _a = this.agreementData.currentData, id = _a.id, capitalCode = _a.capitalCode, tenantCode = _a.tenantCode;
            this.$request({
                url: '/proxy/api/capital/licenseAgreement/sign',
                method: 'post',
                data: {
                    id: id,
                    capitalCode: capitalCode,
                    tenantCode: tenantCode,
                    signStatus: signStatus,
                    operator: this.usernameZh,
                },
            }).then(function (res) {
                if (!res || res.errorCode !== 0) {
                    return;
                }
                _this.$message({
                    type: 'success',
                    message: '协议签署成功',
                });
                _this.$emit('close-dialog');
            });
        },
    },
});
